import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "./../../lib/appconst";

interface WarrantyActivationState extends ListState<any> {
  changeHistories: Array<any>;
}
class WarrantyActivationModule extends ListModule<WarrantyActivationState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
    changeHistories: new Array<any>()
  };
  actions = {
    async getDeactivateReasons(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/WarrantyActivation/deactivate-reasons"
      );
      return result;
    },
    async getAll(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/WarrantyActivation/getAll", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async get(context: ActionContext<WarrantyActivationState, any>, payload: any) {
      let reponse = await Ajax.get(
        `/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/get`
      );
      return reponse.data.result;
    },
    async getChangeHistories(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/WarrantyActivation/${payload.data.id}/change-histories`);
      return result;
    },
    async update(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      await Ajax.put(`/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/update-warranty-activation`, payload.data);
    },
    async activate(context: ActionContext<WarrantyActivationState, any>, payload: any) {
      await Ajax.put(`/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/activate-warranty`, payload.data);
    },
    async checkHiddenCode(context: ActionContext<WarrantyActivationState, any>, payload: any) {
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/check-hidden-code-activate-warranty`, null);
      return result;
    },
    async getTemplateSmsOfCategoryCollectionCode(context: ActionContext<WarrantyActivationState, any>, payload: any) {
      const {
        data: { result },
      } = await Ajax.get(`/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/get-templates-sms-activate-warranty`, null);
      return result;
    },
    async deactive(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      await Ajax.put(`/api/services/app/WarrantyActivation/${payload.data.hiddenCode}/deactivate-warranty`, payload.data);
    },
    async export(
      context: ActionContext<WarrantyActivationState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/warranty-activations${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
   
  };

  mutations = {
    setCurrentPage(state: WarrantyActivationState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: WarrantyActivationState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const warrantyActivationModule = new WarrantyActivationModule();
export default warrantyActivationModule;
